export default {
  emptyAddress: ({ address }) => Object.keys(address).filter(key => address[key] != '' && address[key] != null).length <= 2  
}